import ChatFlow from './ChatFlow'
import gotoFlowComponent from './gotoFlowComponent'
export { gotoFlowComponent }

ChatFlow.gotoFlowComponent = gotoFlowComponent

export default ChatFlow
